import React, { useEffect } from 'react';

const LiverAssessment = () => {
    useEffect(() => {
        // Function to call the actual API
        const handleSync = async () => {
            const rawData = localStorage.getItem("pending_assessment");
            if (!rawData) return;

            try {
                const payload = JSON.parse(rawData);
                debugger;
                const response = await fetch("https://drdineshzirpeapi.mednexusns.com/liverhealth/api/Assessment/submit", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                });

                if (response.ok) {
                    console.log("API Sync Successful ✅");
                    localStorage.removeItem("pending_assessment"); // Clean up
                }
            } catch (err) {
                console.error("API Sync Failed:", err);
            }
        };

        // Listen for the message from the Iframe
        const messageHandler = (event) => {
            if (event.data === "ASSESSMENT_COMPLETE") {
                handleSync();
            }
        };

        window.addEventListener("message", messageHandler);
        return () => window.removeEventListener("message", messageHandler);
    }, []);

    const containerStyle = { width: '100%', height: '100vh', overflow: 'hidden', backgroundColor: '#0b1020' };
    const iframeStyle = { width: '100%', height: '100%', border: 'none', display: 'block' };

    return (
        <div style={containerStyle}>
            <iframe
                src="/assesment.html" 
                title="Liver Health Assessment Tool"
                style={iframeStyle}
                sandbox="allow-scripts allow-same-origin allow-forms allow-downloads"
            />
        </div>
    );
};

export default LiverAssessment;